<!--Generic Page > Left Query Condition-->
<template>
    <div v-if="showQuery" ref="refQuery" style="border-left:1px solid #e8eaec;border-right:1px solid #e8eaec;"
         :style="{width: showCondition ? this.conditionWidth - 10 + 'px' : '15px',transition: 'width 0.1s linear'}">
        <a-row style="border-bottom: 1px solid #e8eaec;height: 35px;">
            <a-col span="20" v-show="showCondition">
                <a-button size="small" type="primary" class="mg5" @click="queryList">{{$t('job.Query')}}</a-button>
                <a-button size="small" type="primary" class="mg5" @click="resetQuery">{{$t('job.Reset')}}</a-button>
            </a-col>
            <a-tooltip placement="topLeft">
                <template slot="title">
                    <span>{{ showCondition ? $t("hide") : $t("show") }}</span>
                </template>
                <a-col span="4" :style="{height: showCondition ? '34px' : '100vh',background: showCondition ? '#ffffff' : '#e7eef8'}" class="hover-bg"
                       style="float: right;text-align: center;width: 15px;cursor: pointer;padding-top: 6px;" @click="hideOrShow">
                    <a-icon :type="showCondition ? 'left' : 'right'" />
                </a-col>
            </a-tooltip>
        </a-row>
        <a-row style="margin-left: 5px;margin-right: 5px;overflow: auto;padding-bottom: 8px;" :style="'height:' + windowHeight + 'px'" :gutter="10">
            <a-form :form="formQuery" v-show="showCondition">
                <a-col :span="24/aRowSeveralColumns" v-for="item in conditionQuery" :key="item.GCD_UID" style="min-height: 80px;">
                    <a-form-item class="genericFrom">
                        <!--控件名称-->
                        {{item.PAGE_NAME}}<br>
                        <!--下拉框-->
                        <a-select v-if="item.PAGE_TYPE == 'Dropdown'"
                                  size="small"
                                  v-decorator="[item.GCD_UID]"
                                  @dropdownVisibleChange="(visible) => dropdownClick(visible,item.GCD_UID,item.CODE_MASTER_GROUP)"
                                  allowClear
                                  :mode="multipleSearch.includes(item.COMPARE_TYPE) ? 'multiple' : 'default'"
                                  showSearch>
                            <a-select-option v-for="selectItem in selectList" :value="selectItem.key">
                                {{selectItem.value}}
                            </a-select-option>
                        </a-select>
                        <!--日期-->
                        <a-date-picker v-else-if="item.PAGE_TYPE == 'Date'"
                                       :placeholder="$t('publicLang.PleaseSelect')"
                                       size="small"
                                       v-decorator="[item.GCD_UID]"
                                       format="YYYY-MM-DD"/>
                        <!--时间-->
                        <a-date-picker v-else-if="item.PAGE_TYPE == 'DateTime'"
                                       style="width: 100%; min-width: 0;"
                                       :placeholder="$t('publicLang.PleaseSelect')"
                                       size="small"
                                       v-decorator="[item.GCD_UID]"
                                       format="YYYY-MM-DD HH:mm:ss"
                                       showTime/>
                        <!--开关-->
                        <a-switch v-else-if="item.PAGE_TYPE == 'Switch'"v-decorator="[item.GCD_UID,{initialValue: false,valuePropName: 'checked'}]"></a-switch>
                        <!--文本框-->
                        <a-textarea v-else-if="item.PAGE_TYPE == 'TextArea'" size="small" v-decorator="[item.GCD_UID]" style="height: 40px;"/>
                        <!--输入框-->
                        <a-input v-else size="small" v-decorator="[item.GCD_UID]" @pressEnter="queryList" allowClear/>
                    </a-form-item>
                </a-col>
            </a-form>
        </a-row>
    </div>
</template>
<script>
    import ajax from '../../api/ajax'
    import api from '../../api/url'
    import moment from "moment";
    import {mapState} from "vuex";
    import Template from "../masterData/reportCom/template";
    export default{
        components: {Template},
        data(){
            return{
                formQuery: this.$form.createForm(this, {}),
                conditionQuery:[],
                selectList:[],
                showQuery:false,
                windowHeight: 0,
                test:false,
                showCondition:true,//默认:true展开,false收缩
                isHover:false,
                multipleSearch:['in','not in'],
            }
        },
        props: {
            gmcUid: {
                type: Number,
                default: function () {
                    return 0;
                }
            },
            aRowSeveralColumns: {
                type: Number,
                default: function () {
                    return 24;
                }
            },
            conditionWidth: {
                type: Number,
                default: function () {
                    return 400;
                }
            },
            skuTableColumns: {
                type: Array,
                default: function() {
                    return [];
                }
            },
        },
        computed: {
            ...mapState(["lang"]),
            ...mapState(["systemParam"]),
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        created() {
            this.queryCondition(true)
        },
        activated() {
            // 每次组件被激活时执行（包括首次创建和缓存后重新激活）
            this.queryCondition(false);
        },
        methods:{
            handleResize() {
                this.$nextTick(() => {
                    if (this.$refs.refQuery) {
                        this.windowHeight = window.innerHeight - this.$refs.refQuery.getBoundingClientRect().top - 35;
                    }
                });
            },
            queryCondition(val){
                let params = {
                    gmcUid: this.gmcUid,
                    language: this.lang
                };
                ajax.get(api.GENERICQUERYCONDITION, params).then(res => {
                    if (res.code == 200) {
                        this.conditionQuery = res.data;
                        let inUse = res.inUse;
                        let inShow = res.inShow;
                        if(inUse == 'Y' && this.conditionQuery != undefined && this.conditionQuery.length > 0){
                            this.showQuery = true;
                            this.$emit("showConQuery", this.showQuery);
                            if(val && inShow == 'N'){
                                this.showCondition = false;
                            }
                            this.defaultCondition();
                            this.handleResize();
                        }
                    }
                });
            },
            queryList(){
                let condition = []
                this.formQuery.validateFields((err, values) => {
                    if(values){
                        for (let i = 0; i < this.conditionQuery.length; i++) {
                            let keyValue = {
                                key: this.conditionQuery[i].GCD_UID,
                                value: values[this.conditionQuery[i].GCD_UID]
                            }
                            if(keyValue.value != undefined){
                                if(this.conditionQuery[i].PAGE_TYPE == 'Date'){
                                    keyValue.value = moment(keyValue.value).format('YYYY-MM-DD')
                                }
                                if(this.conditionQuery[i].PAGE_TYPE == 'DateTime'){
                                    keyValue.value = moment(keyValue.value).format('YYYY-MM-DD HH:mm:ss')
                                }
                                if(this.multipleSearch.includes(this.conditionQuery[i].COMPARE_TYPE) && this.conditionQuery[i].PAGE_TYPE == 'Dropdown'){//下拉框多选
                                    keyValue.value = keyValue.value.join(',')
                                }
                                if (keyValue.value.length > 0 || this.conditionQuery[i].PAGE_TYPE == 'Switch' && keyValue.value){
                                    condition.push(keyValue)
                                }
                            }
                        }
                    }
                });
                this.$emit("conList", condition);
            },
            resetQuery(){
                this.formQuery.resetFields();
            },
            dropdownClick(visible,uid,codeMasterGroup){
                if(visible){
                    this.selectList = []
                    if(codeMasterGroup != null){
                        let params = {
                            group: codeMasterGroup,
                        };
                        ajax.get(api.GETDATABYCODEMASTERGROUP, params).then(res=>{
                            this.selectList = res.data
                        })
                    }
                }
            },
            defaultCondition(){
                let conWidth
                if(this.showCondition){
                    conWidth = this.conditionWidth//展开
                }else {
                    conWidth = 25//折叠
                }
                this.$emit("conWidth", conWidth);
            },
            hideOrShow(){
                this.showCondition = !this.showCondition
                this.defaultCondition();
            },
        }
    }
</script>
<style scoped>
    .hover-bg {
        background-color: #ffffff;
    }
    .hover-bg:hover {
        background-color: #e7eef8 !important; /* 悬停时的背景色 */
        border-radius: 5px;
    }
</style>